import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate, useSearchParams } from 'react-router-dom';
import Qrgeneration from './components/Qrgeneration';
import { useEffect } from 'react';
import Error from './components/Error';

function App() {
  useEffect(() => {
    const handleKey = (e) => {
      if ((e.key === "F5") || (e.ctrlKey && e.key === "r")) {
        e.preventDefault();
        alert('Page reload is disabled!')
      }
    }
    window.addEventListener("keydown", handleKey);
    return () => {
      window.removeEventListener('keydown', handleKey);
    }
  }, [])
  return (
    <Router>
      <Routes>
        <Route path='/' element={<Navigate to='/ae/consumer/consent' />} />
        <Route path='/ae/consumer/consent' element={<Validation />} />
        {/* <Route path='*' element={<Navigate to='/ae/consumer/consent' />} /> */}
        <Route path='*' element={<Navigate to='/error' />} />
        <Route path='/error' element={<Error />} />
      </Routes>
    </Router>
  );
}

function Validation() {
  const [searchParam] = useSearchParams();

  const client_id = searchParam.get('client_id');
  const request_uri = searchParam.get('request_uri');
  if (!client_id || !request_uri) {
    return <Navigate to="/error" />
  }
  return <Qrgeneration />
}

export default App;
